<template>
    <div :style="{width, height}" class="statisDiv">
        <img class="genderImgClass" :src="genderImg" alt="">
        <div class="genderBackClass">
            <div class="totalClass">{{totalText}} <span class="companyClass">{{companyName}}</span> </div>
            <div class="describeClass">{{describeText}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        width: String,
        height: String,
        backImg: String,
        totalText: Number,
        companyName: String,
        describeText: String,
        genderImg: String
    },
    data(){
        return{
        }
    },
}
</script>

<style lang="scss" scoped>
.statisDiv{
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 100%;
}
.genderImgClass{
    margin-left: 5%;
    width: 87%;
    height: 100%;
    background-size: 100% 100%;
}
.genderBackClass{
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 32%;
    width: 70%;
    height: 100%;
    // background-color: #FFFFFF;
}
.totalClass{
    margin-top: 2%;
    font-weight: bold;
    color: #13FFEE;
    text-align: left;
    font-size: 22px;
    vertical-align: bottom;
    // background-color: #FFFFFF;
}
.companyClass{
    align-items: center;
    font-weight: 600;
    font-size: 14px;
    color: #13FFEE;
}
.describeClass{
    margin-top: -2%;
    color: #FFFFFF;
    font-size: 15px;
    text-align: left;
}
@media (max-width:768px){
	.statisDiv{
		width: 80%;
		margin: 20px auto;
		
	}
}
</style>